(function () {
  'use strict';

  d3.chart('ChartBase').extend('ContextChart', {
    initialize : function (options) {
      var plot = this,
          bases, clipperId;
      options = options || {};

      options.chart = options.chart || 'Line';
      plot.ctxHeight = options.ctxHeight || 80;

      // set default padding, but don't override the ones set by options
      plot.padding({ top : 20, bottom : 5, left : 5, right : 5});
      plot.padding(options.padding);

      bases = {
        focus : plot.wrap.append('g').classed('focus', true),
        context : plot.wrap.append('g').classed('context', true),
        legend : plot.wrap.append('g'),
        brush : plot.wrap.append('g').classed('brush', true),
        inspector : plot.wrap.append('g')
      };

      // the main chart
      plot.focus = bases.focus
          .chart(options.chart, options.chartOptions);

      // the zooming context beneath the main chart
      plot.context = bases.context
          .chart(options.chart, _.defaults({
            contextMode : true
          }, options.chartOptions));

      plot.legend = bases.legend
          .chart('Legend', { color : plot.focus.color });

      plot.attach('focus', plot.focus);
      plot.attach('context', plot.context);
      plot.attach('legend', plot.legend);

      // indicates information about the datum under the mouse
      plot.inspector = bases.inspector
          .chart('Inspector', { focus : plot.focus });

      clipperId = uuid();
      // the clipPath masks the plot series
      plot.clipper = plot.defsNode()
          .append('clipPath')
          .attr('id', clipperId)
          .append('rect');

      plot.brush = d3.svg.brush()
          .x(plot.context.x)
          .on('brush', function () {
            var extent = plot.brush.empty() ? plot.brush.x().domain() : plot.brush.extent();
            plot.focus.brushed(extent, clipperId);
            if (plot.brush.empty()) {
              // kick the inspector because it's only listening for mousemove
              plot.inspector.check();
            }
          });

      plot.on('change:width', layout)
          .on('change:height', layout)
          .on('change:data', function () {
            // clear the brush and redraw it
            plot.brush.clear();
            bases.brush.call(plot.brush);
          });

      function layout() {
        var width = plot.w;
        var focusHeight = plot.h - plot.ctxHeight;
        var padding = plot.focus.padding();

        plot.focus
            .width(width)
            .height(focusHeight);

        // clip the focus to its own internal size
        plot.clipper
            .attr('width', Math.max(0, plot.focus.w))
            .attr('height', Math.max(0, plot.focus.h));

        plot.context
            .width(width)
            .height(plot.ctxHeight);

        bases.context
            .translate(0, focusHeight);

        bases.brush
            .translate(padding.left, focusHeight)
            .call(plot.brush)
            .selectAll('rect')
            .attr('height', plot.context.h);

        bases.inspector
            .translate(padding.left, padding.top);

        bases.legend
            .translate(padding.left + 30, -plot.pad('top'));
      }

      plot.focus.on('change:height', function () {
        plot.inspector.height(plot.focus.h);
      });
    },
    transform : function (data) {
      // otherwise plot.redraw() won't work
      this.data = data;
      return data;
    }
  });

})();
